import { createStyles, Theme } from '@zn-material-ui'
import iconBackImg from '@images/login/icon_back.png'

export default (theme: Theme) =>
  createStyles({
    loginContainer: {
      minWidth: '531px',
      paddingLeft: '69px',
      display: 'block',
    },
    agreementContainer: {
      display: 'block',
      paddingTop: '120px',
      height: '100%',
    },
    formContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      position: 'relative',
      backgroundColor: theme.palette.secondary.main,
      [theme.breakpoints.down(1300)]: {
        minWidth: 875,
      },
    },
    back: {
      width: '120px',
      height: '120px',
      [theme.breakpoints.down(1300)]: {
        width: '180px',
        height: '180px',
      },
      backgroundColor: '#F9FAFC',
      backgroundImage: `url(${iconBackImg})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    title: {
      width: '460px',
    },
    headText: {
      fontSize: 40,
      color: '#F4F5F8',
    },
    description: {
      marginTop: 10,
      fontSize: 40,
      color: '#363C46',
      fontWeight: 600,
      wordWrap: 'break-word',
      wordBreak: 'normal',
      overflowWrap: 'break-word',
    },
    titleLine: {
      width: 40,
      height: 5,
      marginTop: 22,
      backgroundColor: theme.palette.primary.main,
    },
  })
